import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

const Roadmap = ({ roadmap, bundleData, updateLessonStatus }) => {

    const swiperRef = useRef(null);
    const [clickedLessons, setClickedLessons] = useState({});
    const statusOrder = {
        "complete": 0,
        "in-progress": 1,
        "upcoming": 2
    };

    // Sort the items by status first and then by the order within each status
    const allItems = Object.values(roadmap)
        .flat()
        .sort((a, b) => {
            const statusDiff = statusOrder[a.status] - statusOrder[b.status];
            if (statusDiff !== 0) return statusDiff;
            return a.order - b.order;
        });

    // Find index of the last completed item
    const lastCompletedIndex = allItems.reduce((lastIndex, item, index) => {
        return item.status === "complete" ? index : lastIndex;
    }, -1);

    // Whenever roadmap changes, slide to last completed
    useEffect(() => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideTo(Math.max(lastCompletedIndex, 0));
        }
    }, [lastCompletedIndex]);

    return (
        <div className="roadmap">
            <p className="instruction">View student roadmap</p>
            {roadmap.length === 0 && (
                <p className="no-roadmap">No roadmap available</p>
            )}
            <div className="roadmap-swiper-cont">
                <Swiper
                    modules={[Navigation, Pagination]}
                    spaceBetween={20} 
                    slidesPerView={5}
                    navigation
                    ref={swiperRef}
                >
                    {allItems.map((item, index) => (
                        <SwiperSlide key={index} className={`slide ${item.status}`}>
                            <p className="status">{item.status}</p>
                            <div className={`roadmap-item ${item.status}`}>
                                <p className="label">{item.level}</p>
                                <p className="label">{item.label}</p>
                                {item.lessons && (
                                    <div className="lessons-list">
                                        {Object.entries(item.lessons).map(([lessonNum, status]) => (
                                            <label
                                                key={lessonNum}
                                                className={`lesson-checkbox ${status}`}
                                                onClick={() => updateLessonStatus(item.level, item.bundle_key, lessonNum)}
                                            >
                                                {`Lesson ${lessonNum}`}
                                            </label>
                                        ))}
                                    </div>
                                )}

                                {item.feedback_form_id &&
                                <p className='feedback-form-p'>
                                    <Link to={`/portal/students/feedback/${item.feedback_form_id}`} className="link">
                                        View Feedback Form
                                    </Link>
                                </p>
                                }

                                { item.status === 'upcoming' ? <p className="order">{item.order}</p> : null }
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default Roadmap;
